/* eslint-disable  */
//@ts-nocheck
import React, { useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Select, MenuItem } from '@mui/material';

import VideoItem from './VideoItem';

const SearchInput = styled.input`
  background: #fff;
  font-weight: 700;
  font-size: 18px;
  border-radius: 10px;
  border: 1px solid black;
`;

function VideoItemList(props) {
  const { videos, removeVideoFromLibrary } = props;
  const sortKeys = ['title', 'duration', 'createdAt', 'fileSize'];
  const [textFilter, setTextFilter] = useState('');
  const [sortBy, setSortBy] = useState({
    key: 'createdAt',
    order: 'DESC',
  });

  function filteredVideos(videos) {
    if (!textFilter) return videos;
    return videos.filter((v) =>
      v.title ? v.title.toLowerCase().includes(textFilter.toLowerCase()) : true,
    );
  }

  function sortedVideos(videos) {
    const sorted = _.sortBy(videos, (v) => v[sortBy.key]);
    return sortBy.order === 'ASC' ? sorted : _.reverse(sorted);
  }

  if (!videos || !videos.length) {
    return (
      <div className="flex justify-center items-center h-[400px]">
        <span style={{ textAlign: 'center' }}>
          You don’t have any long form videos to use. <br /> Tap on the{' '}
          <b>PLUS</b> button to upload long-form videos.
        </span>
      </div>
    );
  }

  return (
    <div>
      <div style={{ padding: '15px' }}>
        <SearchInput
          type="text"
          placeholder="Type to filter videos"
          onChange={(e) => setTextFilter(e.target.value)}
          style={{
            width: '400px',
          }}
        />
        <Select
          placeholder="Sort by"
          style={{ width: '200px', marginRight: '5px', marginLeft: '10px' }}
          value={sortBy.key}
          onChange={(e) =>
            setSortBy({
              order: 'ASC',
              key: e.target.value,
            })
          }
        >
          {sortKeys.map((key) => (
            <MenuItem key={key} value={key}>
              {key}
            </MenuItem>
          ))}
        </Select>
        <Select
          value={sortBy.order}
          onChange={(e) =>
            setSortBy({
              ...sortBy,
              order: e.target.value,
            })
          }
          style={{
            width: '100px',
          }}
        >
          <MenuItem value="ASC">ASC</MenuItem>
          <MenuItem value="DESC">DESC</MenuItem>
        </Select>
      </div>
      <div className="video-library-list">
        {sortedVideos(filteredVideos(videos)).map((v, k) => {
          return (
            <VideoItem
              key={k}
              video={v}
              removeVideoFromLibrary={removeVideoFromLibrary}
            />
          );
        })}
      </div>
    </div>
  );
}

export default VideoItemList;
